// BORRADOR: requiere soporte de modoCompra/modoVenta y montos A/B en el backend.
import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { postRemito } from "../helpers/rutaRemitos";
import { getProveedores } from "../helpers/rutaProveedores";
import { getClientes } from "../helpers/rutaClientes";
import { getTransportes } from "../helpers/rutaTransportes";
import { getChoferes } from "../helpers/rutaChoferes";
const VARIEDADES_SUGERIDAS = ["ATLANTIC", "INNOVATOR", "SPUNTA", "BATATA"];
const todayLocalISO = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
};
const makeInitialForm = () => ({
  fecha: todayLocalISO(),
  nroviaje: "",
  kgCampo: "",
  kgRecibido: "",
  precioCompra: "",
  precioVenta: "",
  proveedor: "",
  cliente: "",
  transporte: "",
  chofer: "",
  variedad: "",
  nroDTVCompra: "",
  nroDTVVenta: "",
  modoCompra: "porcentaje",
  modoVenta: "porcentaje",
  montoCompraA: "",
  montoCompraB: "",
  montoVentaA: "",
  montoVentaB: "",
  porcentajeCompra: 100,
  porcentajeVenta: 100,
  flete: 0,
  facturacompra: "",
  facturaventa: "",
  nota: "",
  factura: true,
});
const parseNumber = (value, def = 0) => {
  if (value === "" || value === null || value === undefined) return def;
  const n = Number(value);
  return Number.isFinite(n) ? n : def;
};
const sortByText = (arr, getter) => {
  return [...(arr || [])].sort((a, b) =>
    String(getter(a) || "").localeCompare(String(getter(b) || ""), "es", {
      sensitivity: "base",
    })
  );
};
const normalizarArray = (data, key) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.[key])) return data[key];
  if (Array.isArray(data?.data)) return data.data;
  return [];
};
const getNombreProveedor = (p) =>
  p?.razonsocial || p?.nombre || p?.proveedor || p?.descripcion || "";
const getNombreCliente = (c) =>
  c?.razonsocial || c?.nombre || c?.cliente || c?.descripcion || "";
const getNombreTransporte = (t) =>
  t?.transporte || t?.razonsocial || t?.nombre || t?.descripcion || "";
const getNombreChofer = (c) =>
  c?.nombre || c?.apellido || c?.razonsocial || c?.descripcion || "";
const money = (n) =>
  Number(n || 0).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
const AddRemitoForm = ({ show, onClose, handleClose, onSaved }) => {
  const cerrar = onClose || handleClose || (() => {});
  const [form, setForm] = useState(makeInitialForm());
  const [guardando, setGuardando] = useState(false);
  const [okModal, setOkModal] = useState(false);
  const [error, setError] = useState("");
  const [listas, setListas] = useState({
    proveedores: [],
    clientes: [],
    transportes: [],
    choferes: [],
    loading: true,
    error: "",
  });
  useEffect(() => {
    const cargarListas = async () => {
      try {
        setListas((prev) => ({
          ...prev,
          loading: true,
          error: "",
        }));
        const [provResp, cliResp, traResp, chofResp] = await Promise.all([
          getProveedores(),
          getClientes(),
          getTransportes(),
          getChoferes(),
        ]);
        setListas({
          proveedores: normalizarArray(provResp, "proveedores"),
          clientes: normalizarArray(cliResp, "clientes"),
          transportes: normalizarArray(traResp, "transportes"),
          choferes: normalizarArray(chofResp, "choferes"),
          loading: false,
          error: "",
        });
      } catch (e) {
        setListas((prev) => ({
          ...prev,
          loading: false,
          error: e?.message || "Error al cargar listas",
        }));
      }
    };
    cargarListas();
  }, []);
  useEffect(() => {
    if (show) {
      setForm(makeInitialForm());
      setError("");
      setOkModal(false);
      setGuardando(false);
    }
  }, [show]);
  const proveedoresOrdenados = useMemo(
    () => sortByText(listas.proveedores, getNombreProveedor),
    [listas.proveedores]
  );
  const clientesOrdenados = useMemo(
    () => sortByText(listas.clientes, getNombreCliente),
    [listas.clientes]
  );
  const transportesOrdenados = useMemo(
    () => sortByText(listas.transportes, getNombreTransporte),
    [listas.transportes]
  );
  const choferesOrdenados = useMemo(
    () => sortByText(listas.choferes, getNombreChofer),
    [listas.choferes]
  );
  const handle = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => {
      const next = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      for (const lado of ["Compra", "Venta"]) {
        const campoA = `monto${lado}A`;
        const campoB = `monto${lado}B`;
        const campoUltimo = `ultimoMonto${lado}`;
        const campoPrecio = `precio${lado}`;
        const campoPorcentaje = `porcentaje${lado}`;

        if (next[`modo${lado}`] !== "monto") continue;

        const editaMonto = name === campoA || name === campoB;
        const cambiaBase =
          name === "kgRecibido" || name === campoPrecio;

        if (!editaMonto && !cambiaBase) continue;

        // Recordamos cuál se ingresó para recalcular el otro.
        const ultimo = editaMonto
          ? name
          : prev[campoUltimo] || campoB;

        next[campoUltimo] = ultimo;

        const base =
          parseNumber(next.kgRecibido) *
          parseNumber(next[campoPrecio]);

        const factorIVA = 1.105;
        const redondear = (n) => Number(n.toFixed(2));

        let baseB;

        if (ultimo === campoA) {
          // A incluye IVA: lo quitamos antes de restar.
          const baseA = parseNumber(next[campoA]) / factorIVA;

          baseB = base - baseA;
          next[campoB] = redondear(baseB);
        } else {
          baseB = parseNumber(next[campoB]);

          next[campoA] = redondear(
            (base - baseB) * factorIVA
          );
        }

        // Sincroniza el porcentaje al volver a ese modo.
        next[campoPorcentaje] =
          base > 0 ? (baseB / base) * 100 : 100;
      }

      return next;
    });
  };
  const kgCampoNum = parseNumber(form.kgCampo);
  const kgRecibidoNum = parseNumber(form.kgRecibido);
  const precioCompraNum = parseNumber(form.precioCompra);
  const precioVentaNum = parseNumber(form.precioVenta);
  const diferencia = kgCampoNum - kgRecibidoNum;
  const baseCompra = kgRecibidoNum * precioCompraNum;
  const baseVenta = kgRecibidoNum * precioVentaNum;
  const pctCompraNegro = Math.min(
    Math.max(parseNumber(form.porcentajeCompra) / 100, 0),
    1
  );
  const pctVentaNegro = Math.min(
    Math.max(parseNumber(form.porcentajeVenta) / 100, 0),
    1
  );
  const IVA_105 = 0.105;
  const compraBPorcentaje = baseCompra * pctCompraNegro;
  const compraAPorcentaje = baseCompra * (1 - pctCompraNegro) * (1 + IVA_105);
  const ventaBPorcentaje = baseVenta * pctVentaNegro;
  const ventaAPorcentaje = baseVenta * (1 - pctVentaNegro) * (1 + IVA_105);
  const compraA = form.modoCompra === "monto" ? parseNumber(form.montoCompraA) : compraAPorcentaje;
  const compraB = form.modoCompra === "monto" ? parseNumber(form.montoCompraB) : compraBPorcentaje;
  const ventaA = form.modoVenta === "monto" ? parseNumber(form.montoVentaA) : ventaAPorcentaje;
  const ventaB = form.modoVenta === "monto" ? parseNumber(form.montoVentaB) : ventaBPorcentaje;

  const cambiarModo = (lado, modo) => {
    setForm((prev) => ({
      ...prev,
      [`modo${lado}`]: modo,
      ...(modo === "monto" && prev[`modo${lado}`] !== "monto" ? {
        [`monto${lado}A`]: (lado === "Compra" ? compraAPorcentaje : ventaAPorcentaje).toFixed(2),
        [`monto${lado}B`]: (lado === "Compra" ? compraBPorcentaje : ventaBPorcentaje).toFixed(2),
      } : {}),
    }));
  };

  const totalCompra = compraA + compraB;
  const totalVenta = ventaA + ventaB;
  const comision = totalVenta - totalCompra;
  const flete = parseNumber(form.flete);
  const validar = () => {
    if (!form.fecha) return "La fecha es obligatoria.";
    if (!form.proveedor) return "Debe seleccionar un proveedor.";
    if (!form.cliente) return "Debe seleccionar un cliente.";
    if (!form.transporte) return "Debe seleccionar un transporte.";
    if (!form.chofer) return "Debe seleccionar un chofer.";
    if (parseNumber(form.kgCampo) <= 0) return "Kg campo debe ser mayor a cero.";
    if (parseNumber(form.kgRecibido) <= 0)
      return "Kg recibido debe ser mayor a cero.";
    if (parseNumber(form.precioCompra) < 0)
      return "Precio compra no puede ser negativo.";
    if (parseNumber(form.precioVenta) < 0)
      return "Precio venta no puede ser negativo.";
    if (form.modoCompra === "porcentaje" && (parseNumber(form.porcentajeCompra) < 0 || parseNumber(form.porcentajeCompra) > 100)) {
      return "% compra negro debe estar entre 0 y 100.";
    }
    if (form.modoVenta === "porcentaje" && (parseNumber(form.porcentajeVenta) < 0 || parseNumber(form.porcentajeVenta) > 100)) {
      return "% venta negro debe estar entre 0 y 100.";
    }
    for (const lado of ["Compra", "Venta"]) {
      if (form[`modo${lado}`] !== "monto") continue;
      for (const tipo of ["A", "B"]) {
        const valor = form[`monto${lado}${tipo}`];
        if (valor === "" || !Number.isFinite(Number(valor)) || Number(valor) < 0) {
          return `Ingrese un monto válido mayor o igual a cero en ${lado} ${tipo}.`;
        }
      }
    }
    return "";
  };
  const submit = async (e) => {
    e.preventDefault();
    const msg = validar();
    if (msg) {
      setError(msg);
      return;
    }
    try {
      setGuardando(true);
      setError("");
      const payload = {
        fecha: form.fecha,
        nroviaje: String(form.nroviaje || "").trim(),
        kgCampo: parseNumber(form.kgCampo),
        kgRecibido: parseNumber(form.kgRecibido),
        precioCompra: parseNumber(form.precioCompra),
        precioVenta: parseNumber(form.precioVenta),
        proveedor: form.proveedor,
        cliente: form.cliente,
        transporte: form.transporte,
        chofer: form.chofer,
        // No usamos lote por ahora
        lote: null,
        variedad: (form.variedad || "").trim().toUpperCase(),
        nroDTVCompra: (form.nroDTVCompra || "").trim(),
        nroDTVVenta: (form.nroDTVVenta || "").trim(),
        // El backend debe conservar estos montos cuando el modo es "monto".
        modoCompra: form.modoCompra,
        modoVenta: form.modoVenta,
        ...(form.modoCompra === "monto" ? { montoCompraA: compraA, montoCompraB: compraB } : {}),
        ...(form.modoVenta === "monto" ? { montoVentaA: ventaA, montoVentaB: ventaB } : {}),
        porcentajeCompra: parseNumber(form.porcentajeCompra),
        porcentajeVenta: parseNumber(form.porcentajeVenta),
        flete: parseNumber(form.flete),
        facturacompra: (form.facturacompra || "").trim(),
        facturaventa: (form.facturaventa || "").trim(),
        nota: form.nota || "",
        factura: !!form.factura,
      };
      const resp = await postRemito(payload);
      if (resp?.ok === false) {
        const backendMsg =
          resp?.err?.message ||
          resp?.error?.err?.message ||
          resp?.error?.message ||
          resp?.error ||
          "No se pudo guardar el remito.";
        throw new Error(
          typeof backendMsg === "string"
            ? backendMsg
            : "No se pudo guardar el remito."
        );
      }
      setOkModal(true);
      setForm(makeInitialForm());
      if (typeof onSaved === "function") {
        onSaved(resp);
      }
    } catch (e2) {
      setError(e2?.message || "Error al guardar el remito.");
    } finally {
      setGuardando(false);
    }
  };
  const cerrarOk = () => {
    setOkModal(false);
    cerrar();
  };
  return (
    <>
      <Modal show={show} onHide={cerrar} size="xl" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Nuevo Remito - Papas</Modal.Title>
        </Modal.Header>
        <form onSubmit={submit}>
          <Modal.Body>
            {listas.loading && (
              <div className="alert alert-info mb-3">
                Cargando datos...
              </div>
            )}
            {listas.error && (
              <div className="alert alert-warning mb-3">
                {listas.error}
              </div>
            )}
            {error && (
              <div className="alert alert-danger mb-3">
                {error}
              </div>
            )}
            <div className="row g-3">
              <div className="col-md-2">
                <label className="form-label">Fecha</label>
                <input
                  type="date"
                  className="form-control"
                  name="fecha"
                  value={form.fecha}
                  onChange={handle}
                  required
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Nro Viaje</label>
                <input
                  type="text"
                  className="form-control"
                  name="nroviaje"
                  value={form.nroviaje}
                  onChange={handle}
                  placeholder="Ej: 1301,1"
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Proveedor</label>
                <select
                  className="form-select"
                  name="proveedor"
                  value={form.proveedor}
                  onChange={handle}
                  required
                >
                  <option value="">Seleccionar proveedor</option>
                  {proveedoresOrdenados.map((p) => (
                    <option key={p._id} value={p._id}>
                      {getNombreProveedor(p)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Cliente</label>
                <select
                  className="form-select"
                  name="cliente"
                  value={form.cliente}
                  onChange={handle}
                  required
                >
                  <option value="">Seleccionar cliente</option>
                  {clientesOrdenados.map((c) => (
                    <option key={c._id} value={c._id}>
                      {getNombreCliente(c)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label">Variedad</label>
                <input
                  list="variedadesRemito"
                  className="form-control"
                  name="variedad"
                  value={form.variedad}
                  onChange={handle}
                  placeholder="Ej: SPUNTA"
                />
                <datalist id="variedadesRemito">
                  {VARIEDADES_SUGERIDAS.map((v) => (
                    <option key={v} value={v} />
                  ))}
                </datalist>
              </div>
              <div className="col-md-2">
                <label className="form-label">Kg Campo</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  name="kgCampo"
                  value={form.kgCampo}
                  onChange={handle}
                  required
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Kg Recibido</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  name="kgRecibido"
                  value={form.kgRecibido}
                  onChange={handle}
                  required
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Diferencia</label>
                <input
                  type="text"
                  className="form-control"
                  value={money(diferencia)}
                  readOnly
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Flete</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  name="flete"
                  value={form.flete}
                  onChange={handle}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Precio Compra</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  name="precioCompra"
                  value={form.precioCompra}
                  onChange={handle}
                  required
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Precio Venta</label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  name="precioVenta"
                  value={form.precioVenta}
                  onChange={handle}
                  required
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Transporte</label>
                <select
                  className="form-select"
                  name="transporte"
                  value={form.transporte}
                  onChange={handle}
                  required
                >
                  <option value="">Seleccionar transporte</option>
                  {transportesOrdenados.map((t) => (
                    <option key={t._id} value={t._id}>
                      {getNombreTransporte(t)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Chofer</label>
                <select
                  className="form-select"
                  name="chofer"
                  value={form.chofer}
                  onChange={handle}
                  required
                >
                  <option value="">Seleccionar chofer</option>
                  {choferesOrdenados.map((c) => (
                    <option key={c._id} value={c._id}>
                      {getNombreChofer(c)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label">DTV Compra</label>
                <input
                  type="text"
                  className="form-control"
                  name="nroDTVCompra"
                  value={form.nroDTVCompra}
                  onChange={handle}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">DTV Venta</label>
                <input
                  type="text"
                  className="form-control"
                  name="nroDTVVenta"
                  value={form.nroDTVVenta}
                  onChange={handle}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Factura Compra</label>
                <input
                  type="text"
                  className="form-control"
                  name="facturacompra"
                  value={form.facturacompra}
                  onChange={handle}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Factura Venta</label>
                <input
                  type="text"
                  className="form-control"
                  name="facturaventa"
                  value={form.facturaventa}
                  onChange={handle}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label">Nota / Observaciones</label>
                <textarea
                  className="form-control"
                  name="nota"
                  value={form.nota}
                  onChange={handle}
                  rows="2"
                />
              </div>
              <div className="col-md-12">
                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="factura"
                    id="facturaRemito"
                    checked={!!form.factura}
                    onChange={handle}
                  />
                  <label className="form-check-label" htmlFor="facturaRemito">
                    Incluir flete en cuenta proveedor
                  </label>
                </div>
              </div>
            </div>
            <hr />
            <div className="row g-3 mb-3">
              {["Compra", "Venta"].map((lado) => {
                const modo = form[`modo${lado}`];
                const color = lado === "Compra" ? "primary" : "danger";
                return (
                  <div className="col-md-6" key={lado}>
                    <div className={`border border-${color} rounded p-3 h-100`}>
                      <h6 className={`text-${color}`}>Distribución {lado}</h6>
                      <div className="btn-group w-100 mb-3" role="group" aria-label={`Distribución ${lado}`}>
                        {[ ["porcentaje", "Por porcentaje"], ["monto", "Por monto"] ].map(([valor, etiqueta]) => (
                          <button key={valor} type="button"
                            className={`btn btn-sm btn-${modo === valor ? "" : "outline-"}${color}`}
                            aria-pressed={modo === valor}
                            onClick={() => cambiarModo(lado, valor)}>
                            {etiqueta}
                          </button>
                        ))}
                      </div>
                      {modo === "porcentaje" ? (
                        <div>
                          <label className="form-label">% {lado} B</label>
                          <input type="number" min="0" max="100" step="any"
                            className="form-control" name={`porcentaje${lado}`}
                            value={form[`porcentaje${lado}`]} onChange={handle} required />
                        </div>
                      ) : (
                        <div className="row g-3">
                          {["A", "B"].map((tipo) => (
                            <div className="col-6" key={tipo}>
                              <label className="form-label">
                                {lado} {tipo}{tipo === "A" ? " (IVA incluido)" : ""}
                              </label>
                              <input type="number" min="0" step="0.01"
                                className="form-control" name={`monto${lado}${tipo}`}
                                value={form[`monto${lado}${tipo}`]} onChange={handle} required />
                            </div>
                          ))}
                          <div className="col-12">
                            <small className="text-muted">Ingresá A o B y se calculará el otro automáticamente. A incluye IVA del 10,5 %.</small>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="row g-3">
              <div className="col-md-3">
                <div className="card border-primary">
                  <div className="card-body">
                    <h6 className="text-primary mb-2">Compra A</h6>
                    <strong>$ {money(compraA)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card border-primary">
                  <div className="card-body">
                    <h6 className="text-primary mb-2">Compra B</h6>
                    <strong>$ {money(compraB)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card border-danger">
                  <div className="card-body">
                    <h6 className="text-danger mb-2">Venta A</h6>
                    <strong>$ {money(ventaA)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card border-danger">
                  <div className="card-body">
                    <h6 className="text-danger mb-2">Venta B</h6>
                    <strong>$ {money(ventaB)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="mb-2">Total Compra</h6>
                    <strong>$ {money(totalCompra)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="mb-2">Total Venta</h6>
                    <strong>$ {money(totalVenta)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="mb-2">Comisión</h6>
                    <strong>$ {money(comision)}</strong>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={cerrar} disabled={guardando}>
              Cancelar
            </Button>
            <Button type="submit" variant="dark" disabled={guardando}>
              {guardando ? "Guardando..." : "Guardar Remito"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal show={okModal} onHide={cerrarOk} centered>
        <Modal.Header closeButton>
          <Modal.Title>Remito guardado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          El remito se guardó correctamente.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={cerrarOk}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AddRemitoForm;